import axios from "axios";
import { useEffect, useMemo, useState } from "react";
import { snakeToCamelCase } from "@/common/common";
const useGetWithAxios = (url, config) => {
    const [status, setStatus] = useState("fetching");
    const [data, setData] = useState();
    const isEnabled = useMemo(() => {
        return config?.enabled === undefined ? true : config.enabled;
    }, [config]);
    useEffect(() => {
        if (!isEnabled) {
            return;
        }
        // Only request once
        if (data) {
            return;
        }
        const source = axios.CancelToken.source();
        (async () => {
            try {
                const { data: responseData } = await axios.get(url, {
                    ...config,
                    cancelToken: source.token,
                });
                if (!responseData.success) {
                    setStatus("error");
                    return;
                }
                setStatus("success");
                setData(snakeToCamelCase(responseData));
            }
            catch (err) {
                console.warn(err);
                setStatus("error");
            }
        })();
        return () => {
            source.cancel("Cancelling in cleanup");
        };
    }, [isEnabled]);
    return {
        data,
        status,
    };
};
export { useGetWithAxios };
